import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LogOut, ExternalLink } from "lucide-react";
import { btn } from "@/components/admin/ui";
import ProjectsTab from "@/components/admin/ProjectsTab";
import SectionsTab from "@/components/admin/SectionsTab";
import CopyTab from "@/components/admin/CopyTab";

const TABS = [
  { id: "projects", label: "Projects" },
  { id: "sections", label: "Sections & Categories" },
  { id: "copy", label: "Page Copy" },
];

export default function Admin() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("projects");

  const reload = useCallback(() => {
    api.get("/admin/content").then((r) => setData(r.data)).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const doLogout = async () => { await logout(); navigate("/"); };

  if (!data) return <div className="min-h-screen grid place-items-center bg-ink text-mute font-mono text-sm">loading…</div>;

  return (
    <div className="min-h-screen bg-ink text-txt" data-testid="admin-dashboard">
      <div className="grain" aria-hidden />
      <header className="sticky top-0 z-40 bg-ink/90 backdrop-blur border-b border-hairline pad-x">
        <div className="max-w-5xl mx-auto flex items-center justify-between h-16">
          <div className="font-mono text-sm">admin · hemanth.kumar_s<span className="blink text-lav">▋</span></div>
          <div className="flex items-center gap-4">
            <Link to="/" target="_blank" className="font-mono text-xs text-mute hover:text-txt flex items-center gap-1.5"><ExternalLink size={13} /> view site</Link>
            <button onClick={doLogout} className="font-mono text-xs text-mute hover:text-lav flex items-center gap-1.5" data-testid="logout-btn"><LogOut size={13} /> logout</button>
          </div>
        </div>
      </header>

      <div className="pad-x py-8">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-wrap gap-2 mb-8">
            {TABS.map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                data-testid={`tab-${t.id}`}
                className={`${btn} border ${tab === t.id ? "bg-lav text-ink border-lav" : "border-hairline text-mute hover:text-txt"}`}
              >
                {t.label}
              </button>
            ))}
          </div>

          {tab === "projects" && <ProjectsTab projects={data.projects} categories={data.categories} reload={reload} />}
          {tab === "sections" && <SectionsTab categories={data.categories} reload={reload} />}
          {tab === "copy" && data.site && <CopyTab site={data.site} reload={reload} />}
        </div>
      </div>
    </div>
  );
}
